import React from "react";
import DropdownContainer from "../../containers/DropdownContainer";

function DateGranularityDropdown() {

  return (
    <DropdownContainer
      dropdown_name="frequency"
    />
  );
}

export default DateGranularityDropdown;
